import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EvaluationType, RecordSliceState } from "../../interface";

const initialState: RecordSliceState = {
  recordIdList: [],
  selectedRecordId: "",
  evaluationList: [],
  selectedEvaluation: null,
  refresh: false,
};

const recordSlice = createSlice({
  name: "record",
  initialState,
  reducers: {
    setRecordList(state, action: PayloadAction<string[]>) {
      state.recordIdList = action.payload;
    },
    setSelectedRecord(state, action: PayloadAction<string>) {
      state.selectedRecordId = action.payload;
    },
    hideRecordDetails(state) {
      state.selectedRecordId = "";
      state.selectedEvaluation = null;
    },
    setSelectedEvaluation(state, action: PayloadAction<EvaluationType>) {
      state.selectedEvaluation = action.payload;
    },
    setEvaluationList(state, action: PayloadAction<EvaluationType[]>) {
      state.evaluationList = action.payload;
    },
    setRefresh(state, action: PayloadAction<boolean>) {
      state.refresh = action.payload;
    },
  },
});

export const {
  setSelectedRecord,
  hideRecordDetails,
  setRecordList,
  setSelectedEvaluation,
  setEvaluationList,
  setRefresh,
} = recordSlice.actions;

export default recordSlice.reducer;
